// extracted by mini-css-extract-plugin
export var instructions = "index-module--instructions--FdvO8";